import React from 'react'

export const AddTeamLayer = () => {
  return (
    <div>AddTeamLayer</div>
  )
}
